"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TabItem = function TabItem(_ref) {
  var eventKey = _ref.eventKey,
      title = _ref.title,
      children = _ref.children,
      variant = _ref.variant,
      disabled = _ref.disabled,
      icon = _ref.icon,
      placementIcon = _ref.placementIcon,
      styleIcon = _ref.styleIcon,
      onClickTab = _ref.onClickTab,
      leftContent = _ref.leftContent,
      rightContent = _ref.rightContent;
  return /*#__PURE__*/_react.default.createElement("div", {
    eventkey: eventKey,
    title: title,
    className: "tab-item ".concat(variant),
    disabled: disabled,
    icon: icon,
    placementicon: placementIcon,
    styleicon: styleIcon,
    onClick: onClickTab,
    leftcontent: leftContent,
    rightcontent: rightContent
  }, children);
};

var _default = TabItem;
exports.default = _default;
TabItem.propTypes = {
  eventKey: _propTypes.default.string.isRequired,
  children: _propTypes.default.element,
  title: _propTypes.default.string.isRequired,
  variant: _propTypes.default.oneOf(['close', 'primary', 'none']),
  disabled: _propTypes.default.bool,
  icon: _propTypes.default.oneOfType([_propTypes.default.func, _propTypes.default.element, _propTypes.default.object]),
  placementIcon: _propTypes.default.oneOf(['right', 'left']),
  styleIcon: _propTypes.default.any,
  onClickTab: _propTypes.default.func,
  leftContent: _propTypes.default.element,
  rightContent: _propTypes.default.element
};
TabItem.defaultProps = {
  children: null,
  variant: 'none',
  disabled: false,
  icon: null,
  placementIcon: 'right',
  styleIcon: {},
  onClickTab: function onClickTab() {},
  leftContent: null,
  rightContent: null
};